import { render, staticRenderFns } from "./api.vue?vue&type=template&id=1cdbe4b7&scoped=true"
import script from "./api.vue?vue&type=script&lang=js"
export * from "./api.vue?vue&type=script&lang=js"
import style0 from "./api.vue?vue&type=style&index=0&id=1cdbe4b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdbe4b7",
  null
  
)

export default component.exports